import _ from 'lodash';
import React from 'react';
import allocationBookingTypes from '~/lookups/allocation-booking-types';
import SingleSelectFilter from './SingleSelectFilter';

const options = _.values(allocationBookingTypes);

export default function AllocationBookingTypeFilter({ placeholder = 'Booking Type', name, value, onChange }) {
  return (
    <SingleSelectFilter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      options={options}
      onChange={onChange}
    />
  );
}
